namespace nscs {
    export class App extends Phaser.Game {

        public static readonly CANVAS_WIDTH:number = 480;
        public static readonly CANVAS_HEIGHT:number = 320;

        constructor() {
            let config:Object = {
                type: nscs.util.Functions.DetectPhaserRenderMode(),
                width: App.CANVAS_WIDTH,
                height: App.CANVAS_HEIGHT,
                physics: {
                    default: 'arcade',
                    arcade: {
                        gravity: {y: nscs.gameplay.Gameplay.gravity0},
                        // debug: true
                    }
                },
                scale: {
                    mode: FitScaleManager.detectBestScaleMode(),
                    autoCenter: Phaser.Scale.CENTER_BOTH
                },
                transparent: false,
                backgroundColor: "0x323232",
                scene: {
                    create: () => {
                        this.scene.add('Boot', nscs.scene.Boot, true);
                    }
                }

            };
            super(config);
        }
    }
}

declare function sendEvent(eventCategory:string, eventAction:string, eventLabel:string);
declare var petaGA_GameCategory_Game;

function toGlobal(object, point?) {
    let pos: { x: number, y: number } = point ? {x: point.x, y: point.y} : {x: 0, y: 0};
    let parentContainer = object;
    while (parentContainer) {
        pos.x *= parentContainer.scaleX;
        pos.y *= parentContainer.scaleY;
        pos.x += parentContainer.x;
        pos.y += parentContainer.y;
        parentContainer = parentContainer.parentContainer;
    }
    return pos;
}

let game:nscs.App;
window.onload = () => {
    nscs.util.Functions.rewriteWordWrapping();

    game = new nscs.App();
};
